import { render, staticRenderFns } from "./ObserverShow.vue?vue&type=template&id=7da7137c"
import script from "./ObserverShow.vue?vue&type=script&lang=js"
export * from "./ObserverShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports